import React from 'react';
import { get_dynamic_styles } from '../../constant/DynamicStyles';

const DividerBlock = ({ styles }) => {
  return <div style={get_dynamic_styles(styles?.divider_styles)} />;
};

export default DividerBlock;
